import { lazy } from 'react';

const HomeEn = lazy(() => import('./components/en/HomeEn').then((module) => ({ default: module.HomeEn })));
const SearchEn = lazy(() => import('./components/en/SearchEn'));

const AppRoutesEn = [

  {
    path: '/en/index',
    element: <HomeEn />
    },
    {
        path: '/en',
        element: <HomeEn />
    },
    {
        path: '/en/search',
        element: <SearchEn />
    },
    {
        path: '/en/search/:searchname',
        element: <SearchEn />
    }
];

export default AppRoutesEn;
